module.exports = __webpack_public_path__ + "img/inline-tablet-arabic.be6a2b68.png";